<template>
  <div style="position:relative;">     
      <validation-provider 
          :rules="datadb[inputTabla][inputCampo].validate" immediate  
          v-slot="{ errors, required }"
          :name="indexIndex+namePath+inputTabla+inputCampo+index" 
          style="position:relative" 
          v-if="datadb[inputTabla][inputCampo].datatype.type==='check'"> 
        <b-form-checkbox
              :id="indexIndex+namePath+inputTabla+inputCampo+index"
              :name="indexIndex+namePath+inputTabla+inputCampo+index"
              size="lg"
              v-model="dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo]"
              @change="changeInput"
              @input="inputInput"
            >
        </b-form-checkbox>        
      </validation-provider>

      <validation-provider :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors, required }"
            :name="indexIndex+namePath+inputTabla+inputCampo+index" 
             v-if="datadb[inputTabla][inputCampo].datatype.type==='input'"> 
          <b-form-input
            v-if="datadb[inputTabla][inputCampo].datatype.type==='input'"
            :id="indexIndex+namePath+inputTabla+inputCampo+index"
            :name="indexIndex+namePath+inputTabla+inputCampo+index"
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])}"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])"
            size="sm"
            :trim="true"
            :type="datadb[inputTabla][inputCampo].type"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo]"            
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
            >
          </b-form-input>
      </validation-provider>

      <validation-provider  v-if="datadb[inputTabla][inputCampo].datatype.type==='price'" immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }" style="position:relative">     
        <vue-numeric 
          v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])===false}"
          separator="."   
          class="form-control" 
          :empty-value="datadb[inputTabla][inputCampo].datatype.predeterminate"       
          :id="indexIndex+namePath+inputTabla+inputCampo+index"
          :name="indexIndex+namePath+inputTabla+inputCampo+index"
          v-model="dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo]"          
          :precision="datadb[inputTabla][inputCampo].datatype.precision"
          :read-only="datadb[inputTabla][inputCampo].datatype.readonly"
          :read-only-class="datadb[inputTabla][inputCampo].datatype.readonlyclass"
          @input="inputInput"
          @blur="blurInput" >
        </vue-numeric>   
      </validation-provider>   

      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"  v-if="datadb[inputTabla][inputCampo] .datatype.type==='textarea'" style="position:relative">  
          <b-form-textarea 
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])"
            :trim="true"
            :id="indexIndex+namePath+inputTabla+inputCampo+index"
            :name="indexIndex+namePath+inputTabla+inputCampo+index"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo]"
            :no-resize="datadb[inputTabla][inputCampo].datatype.noresize"
            :rows="datadb[inputTabla][inputCampo].datatype.rows"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
          ></b-form-textarea>  
      </validation-provider>  
      
      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"           v-if="datadb[inputTabla][inputCampo].datatype.type==='file'" style="position:relative">  
        <editor
            v-if="data.loaded"
            ref="editor"
            :data="data"
          />
          <loader
            ref="loader"
            :data="data"
            :tabla="inputTabla"
            :campo="inputCampo"
            :indexTable="index"
            :indexGet="indexIndex"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])"
          />       
      </validation-provider>  
       
      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"             v-if="datadb[inputTabla][inputCampo].datatype.type==='date'" style="position:relative">  
        <input 
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])===false}"            
            :id="indexIndex+namePath+inputTabla+inputCampo+index"
            :name="indexIndex+namePath+inputTabla+inputCampo+index"
            class="input-date" 
            type="date"  
            v-model="dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo]"            
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput">      
      </validation-provider>

 
      <validation-provider  v-if="datadb[inputTabla][inputCampo].datatype.type==='ftn'"   :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors, required }"
          :name="indexIndex+namePath+inputTabla+inputCampo+index" style="position:relative"> 
        <b-form-input
          v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])}"
          :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])"
          size="sm"
          :trim="true"
          :id="indexIndex+namePath+inputTabla+inputCampo+index"
          :name="indexIndex+namePath+inputTabla+inputCampo+index"
          :type="datadb[inputTabla][inputCampo].type"
          :placeholder="datadb[inputTabla][inputCampo].placeholder"
          v-model="dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo]"          
          @change="changeInput(datadb[inputTabla][inputCampo].id)"
          @input="inputInput(datadb[inputTabla][inputCampo].id)"
          @update="updateInput(datadb[inputTabla][inputCampo].id)"
          @blur="blurInput(datadb[inputTabla][inputCampo].id)"
          >
        </b-form-input>
      </validation-provider>

      <validation-provider  
        v-if="datadb[inputTabla][inputCampo].datatype.type==='select'" immediate 
        :rules="datadb[inputTabla][inputCampo].validate" 
        v-slot="{ errors }" 
        style="position:relative">     
        <c-multiselect  
          v-bind:class="{'is-invalid': veevalidateSelect(errors[0],datadb[inputTabla][inputCampo].validate,dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo])===false}"
          :id="indexIndex+namePath+inputTabla+inputCampo+index"
          :name="indexIndex+namePath+inputTabla+inputCampo+index"
          :placeholder="datadb[inputTabla][inputCampo].placeholder"
          v-model="dataGet[namePath].data[indexIndex][inputTabla][index][inputCampo]"          
          :options="list_name"
          :label="datadb[inputTabla][inputCampo].datatype.label"
          :allow-empty="false"
          @input="InputSelect($event,datadb[inputTabla][inputCampo].id)"
          @select="SelectSelect($event,datadb[inputTabla][inputCampo].id)"
          @remove="removeSelect($event,datadb[inputTabla][inputCampo].id)"
          @search-change="searchChangeSelect($event,datadb[inputTabla][inputCampo].id)"
          @tag="tagSelect($event,datadb[inputTabla][inputCampo].id)"
          @open="openSelect($event,datadb[inputTabla][inputCampo].id)"
          @close="closeSelect($event,datadb[inputTabla][inputCampo].id)">									 
        </c-multiselect> 
      </validation-provider> 
    </b-form-group>  
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Multiselect  from '@/components/vue-multiselect/src/'
import { ValidationProvider } from 'vee-validate'
import '@/mixings/validate.js'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
export default 
{
  name: 'swinputs',
  props: { 
    inputTabla: {
      type: String,
      default: false
    },
    inputCampo: {
      type: String,
      default: false
    },
    sm : {
      type: Number,
      default: 12
    },
    md : {
      type: Number,
      default: 6
    },
    lg : {
      type: Number,
      default: 3
    },
    indexIndex: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },

  },
  data() 
  {
    return {      
			data: {
			  cropped: false,
			  cropping: false,
			  loaded: false,
			  name: '',
        previousUrl: '',
        index: 0,
			  type: '',
        url: '',
        url2: '',
        close1: false,
        close2: false
      },
    }
  },
  components: {
    'c-multiselect': Multiselect,
    VueNumeric,
    ValidationProvider
  },
  created()
  {
  },
  computed:
  {
    list_name() 
    {
      if(this.datadb[this.inputTabla][this.inputCampo].datatype.list==='list_')
      {
       return this.lists[this.dataGet[this.namePath].data[this.indexIndex][this.inputTabla][this.index].name_list]
      }
      return this.lists[this.datadb[this.inputTabla][this.inputCampo].datatype.list]      
    }
  },
  methods: { 
      inputInput(input)
      {
        this.$emit('input', input)
      },
      updateInput(update)
      {
        this.$emit('update', update)
      },
      blurInput()
      {
        this.$emit('blur')
      }  ,
      changeInput(change)
      {
        this.$emit('change', change)
      },
      veevalidateInputs(rules,validate,value='')
      {
        if(validate!=='') 
        {
          if(['', null, undefined].indexOf(rules) === -1)
          {
            return false
          }
          return null
        }
        return null
      },
      
      InputSelect(event,id)
      {
        this.$emit('input', {id: id, obj: event})
      },
      SelectSelect(event,id)
      {
        this.$emit('select',{id: id, obj: event})
      },
      removeSelect(event,id)
      {
        this.$emit('remove', {id: id, obj: event})
      },
      searchChangeSelect(event,id)
      {
        this.$emit('search-change', {id: id, obj: event})
      },
      tagSelect(event,id)
      {
        this.$emit('tag', {id: id, obj: event})
      },
      openSelect(event,id)
      {
        this.$emit('open', {id: id, obj: event})
      },
      closeSelect(event,id)
      {
        this.$emit('close', {id: id, obj: event})
      },
      veevalidateSelect(rules,validate,value='')
      {
        if(validate!=='')
        {
          if(['', undefined].indexOf(rules) === -1)
          {
            return false
          }
          return null
        }
        return null
      } 
  }
}
</script>
<style>
  .form-group{
    margin: 10px 0;
  }
  .form-control {
    margin-bottom: 15px;
    width: 100% !important
  }
  .form-control:focus {
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .custom-select {
    width: 100% !important;
  }
  .custom-select:focus {
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .form-control.is-valid:focus{
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .form-control.is-invalid:focus{
    -webkit-box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
  }
  .custom-file-input.is-valid:focus ~ .custom-file-label {
    -webkit-box-shadow: 0 0 0 0.4px rgba(40, 167, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(40, 167, 69, 0.25)
   }
  .custom-file-input.is-invalid:focus ~ .custom-file-label {    
    border-color: #dc3545;
    -webkit-box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25)
   }
   .form-control-readonly
   {
    background-color: #e9ecef;
    opacity: 1
   }
   .input-group .input-group-text {
     max-height: 31px;
   }
   .input-group span {   
    flex: 1 1 0%;
   }
   .input-errors {
     position: absolute;
     left: 0;
     bottom: 0;
     font-size: 12px;
     line-height: 12px;
   }
   .input-errors-table-table {
     position: absolute;
     left: 0;
     bottom: -14px;
     font-size: 12px;
     line-height: 12px;
   }
   .textarea-errors {
     position: absolute;
     left: 0;
     bottom: -18px;
     font-size: 12px;
     line-height: 12px;
   }
   .file-errors {
     position: absolute;
     left: 0;
     bottom: -21px;
     font-size: 12px;
     line-height: 12px;
   }
   .custom-file-input:focus ~ .custom-file-label {
     border-color: #80bdff;
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
   }
   .custom-file.is-invalid .custom-file-label {
     border-color: #dc3545;
   }   
  .input-date {
    width: 100%;
    border: 1px solid #cecece;
    padding: 5px 2px;
    height: 30px;
    border-radius: 3px;
    background: white;
  }
  .input-date:focus{
     border-color: #80bdff;
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .input-date.is-invalid {
     border-color: #dc3545;
   } 
  .input-date:disabled{
    background-color: #e9ecef;
    opacity: 1;
   }   
       
</style>